import type { ReactNode } from "react";
import "./specificationsArea.css";

type Props = {
  children?: ReactNode;
};

export const SpecificationsArea = ({ children }: Props) => {
  return <div className="specifications-area border-t mt-40 pt-40">{children}</div>;
};
